import { Routes } from '@angular/router';
import { acessoGuard } from './core/acesso/acesso.guard';
import { identificacaoGuard } from './core/acesso/identificacao.guard';
import { MainLayoutComponent } from './shared/layouts/main-layout/main-layout.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'acesso',
        loadComponent: () => import('./features/acesso/entrada.component').then(m => m.EntradaComponent)
      },
      {
        path: 'cadastro-colaborador',
        loadComponent: () => import('./features/cadastro-colaborador/cadastro-colaborador.component').then(m => m.CadastroColaboradorComponent)
      },
      {
        path: 'home',
        loadComponent: () => import('./features/home/home.component').then(m => m.HomeComponent)
      },
      {
        path: 'referencias-encargos',
        loadComponent: () => import('./features/referencias-encargos/referencias-encargos.component').then(m => m.ReferenciasEncargosComponent)
      },
      {
        path: 'autorizacoes-gerenciais',
        loadComponent: () => import('./features/autorizacoes-gerenciais/autorizacoes-gerenciais.component').then(m => m.AutorizacoesGerenciaisComponent)
      },
      {
        path: 'relatorios-precos',
        canActivate: [identificacaoGuard],
        loadComponent: () => import('./features/relatorios-precos/relatorios-precos.component').then(m => m.RelatoriosPrecosComponent)
      },

      {
        path: 'consulta-insumos',
        loadComponent: () => import('./features/consulta-insumos/consulta-insumos.component').then(m => m.ConsultaInsumosComponent)
      },
      {
        path: 'consulta-insumos/:chaveInsumo/historico',
        loadComponent: () => import('./features/consulta-insumos/historico/historico.component').then(m => m.HistoricoInsumoComponent)
      },
      {
        path: 'consulta-servicos',
        loadComponent: () => import('./features/consulta-servicos/consulta-servicos.component').then(m => m.ConsultaServicosComponent)
      },
      {
        path: 'consulta-servicos/:numeroPreco/historico',
        loadComponent: () => import('./features/consulta-servicos/detalhe-servico.component').then(m => m.DetalheServicoComponent)
      },
      {
        path: 'consulta-servicos/:numeroPreco',
        loadComponent: () => import('./features/consulta-servicos/detalhe-servico.component').then(m => m.DetalheServicoComponent)
      },
      {
        path: 'contratacoes',
        canActivate: [acessoGuard('contratacoes')],
        loadComponent: () => import('./features/contratacoes/pages/contratacoes-lista/contratacoes-lista.component').then(m => m.ContratacoesListaComponent)
      },
      {
        path: 'contratacoes/nova',
        canActivate: [acessoGuard('contratacoes')],
        loadComponent: () => import('./features/contratacoes/pages/contratacao-cadastro/contratacao-cadastro.component').then(m => m.ContratacaoCadastroComponent)
      },
      {
        path: 'contratacoes/:id/editar',
        canActivate: [acessoGuard('contratacoes')],
        loadComponent: () => import('./features/contratacoes/pages/contratacao-edicao/contratacao-edicao.component').then(m => m.ContratacaoEdicaoComponent)
      },
      {
        path: 'gestao-orcamentos',
        loadChildren: () => import('./features/gestao-orcamentos/gestao-orcamentos.routes').then(m => m.GESTAO_ORCAMENTOS_ROUTES)
      },
      {
        path: 'orcamentos/:orcamentoId/resumos',
        canActivate: [acessoGuard('planilhas')],
        loadComponent: () => import('./features/resumos-orcamento/resumos-orcamento.component').then(m => m.ResumosOrcamentoComponent)
      },
      {
        path: 'orcamentos/:orcamentoId/participacao-servicos',
        canActivate: [identificacaoGuard],
        loadComponent: () => import('./features/participacao-servicos/participacao-servicos.component').then(m => m.ParticipacaoServicosComponent)
      },
      {
        path: 'orcamentos/:id/duplicar',
        canActivate: [acessoGuard('planilhas')],
        loadComponent: () => import('./features/duplicacao/duplicacao.component').then(m => m.DuplicacaoComponent)
      },
      {
        path: 'orcamentos/:id/redistribuicao',
        canActivate: [acessoGuard('planilhas')],
        loadComponent: () => import('./features/redistribuicao/redistribuicao.component').then(m => m.RedistribuicaoComponent)
      },
      {
        path: 'orcamentos/:orcamentoId/referencia',
        canActivate: [acessoGuard('planilhas')],
        loadComponent: () => import('./features/orcamentos/referencia/referencia.component').then(m => m.ReferenciaComponent)
      },
      {
        path: 'orcamentos/:orcamentoId/itens',
        canActivate: [acessoGuard('planilhas')],
        loadComponent: () => import('./features/itens-orcamento/itens-orcamento.component').then(m => m.ItensOrcamentoComponent)
      },
      {
        path: 'orcamentos/:orcamentoId/consistencia',
        canActivate: [acessoGuard('planilhas')],
        loadComponent: () => import('./features/consistencia-orcamento/consistencia-orcamento.component').then(m => m.ConsistenciaOrcamentoComponent)
      },
      {
        path: 'orcamentos/:orcamentoId/planilha-completa',
        canActivate: [acessoGuard('planilhas')],
        loadComponent: () => import('./features/apresentacao-orcamento/planilha-completa.component').then(m => m.PlanilhaCompletaComponent)
      },
      {
        path: 'orcamentos/:orcamentoId/servicos-ofertados',
        canActivate: [acessoGuard('planilhas')],
        loadComponent: () => import('./features/apresentacao-orcamento/servicos-ofertados.component').then(m => m.ServicosOfertadosComponent)
      },
      {
        path: 'orcamentos/:orcamentoId/importacao-planilha',
        canActivate: [acessoGuard('planilhas')],
        loadComponent: () => import('./features/importacao-planilha/importacao-planilha.component').then(m => m.ImportacaoPlanilhaComponent)
      },
      {
        path: 'orcamentos/:id/importacao-projetista',
        canActivate: [acessoGuard('planilhas')],
        loadComponent: () => import('./features/importacoes-projetistas/importacao-projetista.component').then(m => m.ImportacaoProjetistaComponent)
      },
      {
        path: 'orcamentos/:orcamentoId/servicos-especiais',
        canActivate: [acessoGuard('planilhas')],
        loadComponent: () => import('./features/catalogo-especial/pages/servicos-especiais-orcamento.component').then(m => m.ServicosEspeciaisOrcamentoComponent)
      },
      {
        path: 'catalogo-especial',
        canActivate: [identificacaoGuard],
        loadComponent: () => import('./features/catalogo-especial/pages/consulta-especial.component').then(m => m.ConsultaEspecialComponent)
      },
      {
        path: 'catalogo-especial/novo',
        canActivate: [identificacaoGuard],
        loadComponent: () => import('./features/catalogo-especial/pages/cadastro-especial.component').then(m => m.CadastroEspecialComponent)
      },
      {
        path: 'catalogo-especial/orcamento/:orcamentoId',
        canActivate: [identificacaoGuard],
        loadComponent: () => import('./features/catalogo-especial/pages/orcamento-especial.component').then(m => m.OrcamentoEspecialComponent)
      }
    ]
  },
  { path: '**', redirectTo: 'home' }
];
